// #region Imports
import React, { useEffect, useState, useRef, useCallback } from 'react';
import './CaixaCrud.scss';
// #endregion

export default function CaixaCrud({ open = false, onClose = () => {}, onCreate = () => {} }) {
  // #region Estado
  const [form, setForm] = useState({
    data_referencia: '',
    data_abertura: '',
    valor_inicial: 0,
    valor_estimado: 0,
    valor_real: 0,
    status: 'ABERTO',
    observacoes: '',
  });
  const overlayRef = useRef(null);
  const firstRef = useRef(null);
  // #endregion

  // #region Efeitos
  useEffect(() => {
    if (open) {
      const now = new Date();
      const isoDate = now.toISOString().substring(0, 10);
      setForm(f => ({
        ...f,
        data_referencia: isoDate,
        data_abertura: now.toISOString().substring(0, 16),
      }));
      setTimeout(() => { if (firstRef.current) firstRef.current.focus(); }, 60);
    }
  }, [open]);

  const onKeyDown = useCallback(e => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => {
    if (!open) return;
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onKeyDown]);
  // #endregion

  // #region Early return
  if (!open) return null;
  // #endregion

  // #region Handlers
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function submit(e) {
    e.preventDefault();
    if (!form.data_referencia) {
      alert('Data de referência é obrigatória');
      return;
    }
    const payload = {
      ...form,
      valor_inicial: Number(form.valor_inicial) || 0,
      valor_estimado: Number(form.valor_estimado) || 0,
    };
    onCreate(payload);
    onClose();
  }

  function handleOverlay(e) {
    if (e.target === overlayRef.current) onClose();
  }
  // #endregion

  // #region Render
  return (
    <div className="crud-overlay" ref={overlayRef} onMouseDown={handleOverlay} role="dialog" aria-modal="true">
      <div className="crud-modal caixa-crud" role="document">
        <form className="crud-form" onSubmit={submit}>
          <h3>Novo Caixa</h3>
          <div className="form-grid">
            <div className="fg-item">
              <label htmlFor="f-data-ref">Data de Referência *</label>
              <input id="f-data-ref" type="date" name="data_referencia" ref={firstRef} value={form.data_referencia} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-status">Status *</label>
              <select id="f-status" name="status" value={form.status} onChange={handleChange} required>
                <option value="ABERTO">Aberto</option>
              </select>
            </div>
            <div className="fg-item">
              <label htmlFor="f-data-abertura">Data/Hora de Abertura *</label>
              <input id="f-data-abertura" type="datetime-local" name="data_abertura" value={form.data_abertura} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-valor-inicial">Valor Inicial *</label>
              <input id="f-valor-inicial" name="valor_inicial" type="number" step="0.01" value={form.valor_inicial} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-valor-estimado">Valor Estimado *</label>
              <input id="f-valor-estimado" name="valor_estimado" type="number" step="0.01" value={form.valor_estimado} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-valor-real">Valor Real *</label>
              <input id="f-valor-real" name="valor_real" type="number" step="0.01" value={form.valor_real} disabled />
            </div>
            <div className="fg-item fg-span-2">
              <label htmlFor="f-observacoes">Observações</label>
              <textarea id="f-observacoes" name="observacoes" value={form.observacoes} onChange={handleChange} placeholder="Observações sobre o caixa..." />
            </div>
          </div>
          <div className="crud-actions">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary">Criar Caixa</button>
          </div>
        </form>
      </div>
    </div>
  );
  // #endregion
}
